import dayjs from 'dayjs';
import { SortOrder } from '../enums/sortorder.enum';
import { Sort } from '../interfaces/sort.interface';

export function dataTableSort<Tentity extends { [key: string]: any }>(entities: Tentity[], sort: Sort): Tentity[] {
  const order: number = sort?.sortOrder === SortOrder.DESC ? -1 : 1;

  return [...entities
    .sort((entity1, entity2) => {

      const value1 = _getValue(entity1, sort.sortField);
      const value2 = _getValue(entity2, sort.sortField);

      let result = 0;

      if (sort.sortFunction) {
        result = sort.sortFunction(entity1, entity2);
      } else if (typeof value1 === 'number') {
        result = value1 - value2;
      } else if (typeof value1 === 'string') {
        if (dayjs(value1).isValid() && dayjs(value2).isValid()) {
          result = dayjs(value1).isBefore(value2) ? 1 : dayjs(value2).isBefore(value1) ? -1 : 0;
        } else {
          result = (value1 as string || '').toLocaleLowerCase().localeCompare(value2?.toLocaleLowerCase() || '');
        }
      } else {
        result = value1 - value2;
      }

      return result * order;
    })];
}

function _getValue<TEntity extends { [key: string]: any }>(entity: TEntity, sortField: string): any {
  const sortFields: string[] = sortField.split('.');
  let value = entity;

  for (const prop of sortFields) {
    value = value[prop];
  }

  return value;
}
